export type GenericFunction = (...args: any[]) => any;
export type GenericObject = Record<string, any>;
export type ButtonVariant = "text" | "outlined" | "contained";
export type ButtonColor = "inherit" | "primary" | "secondary" | "default";
export type ButtonSize = "small" | "medium" | "large";
export type IconFontSize = "inherit" | "default" | "small" | "large";
export type Language = "ar" | "en";

export enum WeekDay {
  saturday = "saturday",
  sunday = "sunday",
  monday = "monday",
  tuesday = "tuesday",
  wednesday = "wednesday",
  thursday = "thursday",
  friday = "friday",
}
